import { create } from 'zustand';

export const ConnectionState = {
  Disconnected: 'disconnected',
  Connecting: 'connecting',
  Authenticating: 'authenticating',
  Subscribing: 'subscribing',
  Connected: 'connected',
} as const;

export type ConnectionState = typeof ConnectionState[keyof typeof ConnectionState];

type HubState = {
  connectionState: ConnectionState;
  setConnectionState(state: ConnectionState): void;
  reset(): void;
};

export const useHubStore = create<HubState>((set) => ({
  connectionState: ConnectionState.Disconnected,

  setConnectionState: (state) => set({ connectionState: state }),

  reset: () => set({ connectionState: ConnectionState.Disconnected }),
}));

/** Selector: true when fully connected and subscribed */
export const selectIsConnected = (state: HubState) => state.connectionState === ConnectionState.Connected;
